'use strict';

var JQXTreeNodeColumnFactory = function JQXTreeNodeColumnFactory(Node) {
  function ColumnNode(params) {
    Node.call(this, params);
    this.groupId = params.groupId;
    this.groupLabel = params.groupLabel;
    this.originalLabel = params.originalLabel;
    this.formula = params.formula;
  }
  ColumnNode.prototype = Object.create(Node.prototype);
  ColumnNode.prototype.constructor = ColumnNode;
  ColumnNode.prototype.showGroup = function () {
    if (this.groupLabel && this.originalLabel) {
      this.label = this.originalLabel + ' ' + this.groupLabel;
    }
  };
  ColumnNode.prototype.hideGroup = function () {
    if (this.groupLabel && this.originalLabel) {
      this.label = this.originalLabel;
    }
  };
  ColumnNode.prototype.isChildOf = function (item) {
    return this.groupId === (item.id || item);
  };
  return ColumnNode;
};
JQXTreeNodeColumnFactory.$inject = ['JQXTreeNodeFactory'];
module.exports = JQXTreeNodeColumnFactory;